import React, {Component} from "react";

import {
  Deck,
  Heading,
  Image,
  ListItem,
  List,
  Slide,
  Text
} from "spectacle";

import createTheme from "spectacle/lib/themes/default";

require("normalize.css");

const theme = createTheme({
  primary: "#FAFAF8",
  secondary: "#181004",
  tertiary: "#789ACA",
  quartenary: "#A8C8F0"
}, {
  primary: {
    name: "Savoye LET",
    googleFont: false
  },
  secondary: {
    name: "Noto Sans",
    googleFont: true
  }
});

const darken = "0.2";
const lineHeight = 0.85;

export default class Presentation extends Component {
  render() {
    return (
      <Deck
        theme={theme}
        progress={"none"}
        bgColor={"secondary"}
        controls={false}
        contentWidth={"90%"}>
        <Slide bgImage={"images/bg-0.jpg"} bgDarken={darken} align={"right center"}>
          <Heading
            style={{
            letterSpacing: 1,
            textShadow: "0px 0px 3px #000000",
            width: "50vw",
            float: "right",
            fontSize: "8em"
          }}
            lineHeight={lineHeight}
            textAlign={"right"}
            textColor="primary">
            {"Better User Experience With Animations"}
          </Heading>
          <Text
            textColor="primary"
            textAlign={"right"}
            style={{
            letterSpacing: 1,
            textShadow: "0px 0px 3px #000000",
            width: "33vw",
            float: "right",
            clear: "both",
            fontSize: "4em"
          }}>{"\"How to Make Your Users Even Happier\""}</Text>
        </Slide>
        <Slide bgImage={"images/bg-0.jpg"} bgDarken={darken}>
          <Heading
            style={{
            letterSpacing: 1,
            textShadow: "0px 0px 3px #000000",
            width: "50vw",
            float: "right",
            fontSize: "8em",
            textAlign: "right"
          }}
            textColor="primary"
            lineHeight={lineHeight}>
            {"This is Today's Story"}
          </Heading>
          <List
            style={{
            listStyleType: "none",
            textAlign: "right",
            clear: "both"
          }}>
            <ListItem
              margin={"10px 0px"}
              style={{
              textShadow: "0px 0px 3px #000000"
            }}
              textSize={60}
              textColor={"primary"}
              textFont={"Noto Sans"}>
              {"Why to Animate"}
            </ListItem>
            <ListItem
              margin={"10px 0px"}
              style={{
              textShadow: "0px 0px 3px #000000"
            }}
              textSize={60}
              textColor="primary"
              textFont={"Noto Sans"}>
              {"Animation Libraries"}
            </ListItem>
            <ListItem
              margin={"10px 0px"}
              style={{
              textShadow: "0px 0px 3px #000000"
            }}
              textSize={60}
              textColor="primary"
              textFont={"Noto Sans"}>
              {"Live Example"}
            </ListItem>
            <ListItem
              margin={"10px 0px"}
              style={{
              textShadow: "0px 0px 3px #000000"
            }}
              textSize={60}
              textColor="primary"
              textFont={"Noto Sans"}>
              {"Conclusions"}
            </ListItem>
          </List>
        </Slide>
        <Slide bgImage={"images/bg-1.jpg"} bgDarken={darken}>
          <Heading
            style={{
            letterSpacing: 1,
            textShadow: "0px 0px 3px #000000",
            fontSize: "8em",
            textAlign: "center"
          }}
            textColor="primary">
            {"Why to Animate"}
          </Heading>
          <Text
            margin={"20px auto"}
            style={{
            lineHeight: "1.25em",
            width: "50vw",
            textShadow: "0px 0px 3px #000000"
          }}
            textSize={60}
            textColor="primary"
            textFont={"Noto Sans"}>
            Animations are a
            <b
              style={{
              color: "#A0E0FF",
              margin: "0px 12px"
            }}>
              powerful tool
            </b>
            for communication
          </Text>
        </Slide>
        <Slide bgImage={"images/bg-1.jpg"} bgDarken={darken}>
          <Heading
            style={{
            letterSpacing: 1,
            textShadow: "0px 0px 3px #000000",
            fontSize: "8em",
            textAlign: "center"
          }}
            textColor="primary">
            {"Why to Animate"}
          </Heading>
          <Text
            margin={"20px auto"}
            style={{
            lineHeight: "1.25em",
            width: "50vw",
            textShadow: "0px 0px 3px #000000"
          }}
            textSize={60}
            textColor="primary"
            textFont={"Noto Sans"}>
            Animations are both
            <b
              style={{
              color: "#A0E0FF",
              margin: "0px 12px"
            }}>
              blessing and a curse</b>
          </Text>
        </Slide>
        <Slide bgImage={"images/bg-2.jpg"} bgDarken={darken}>
          <Heading
            style={{
            letterSpacing: 1,
            textShadow: "0px 0px 3px #000000",
            fontSize: "8em",
            textAlign: "center"
          }}
            textColor="primary">
            {"Designer's Story"}
          </Heading>
        </Slide>
        <Slide bgImage={"images/bg-2.jpg"} bgDarken={darken}>
          <Image
            src="images/rneu-layout.jpg"
            style={{
            border: "2px solid #202020"
          }}/>
        </Slide>
        <Slide bgImage={"images/bg-2.jpg"} bgDarken={darken}>
          <Heading
            style={{
            letterSpacing: 1,
            textShadow: "0px 0px 3px #000000",
            fontSize: "8em",
            textAlign: "center"
          }}
            textColor="primary">
            {"Animation Libraries"}
          </Heading>
        </Slide>
        <Slide bgImage={"images/bg-3.jpg"} bgDarken={darken}>
          <Image
            src={"images/carbon-animated.png"}
            style={{
            height: '85vh'
          }}/>
        </Slide>
        <Slide bgImage={"images/bg-3.jpg"} bgDarken={darken}>
          <Image
            src={"images/carbon-reanimated.png"}
            style={{
            height: '85vh'
          }}/>
        </Slide>
        <Slide bgImage={"images/bg-3.jpg"} bgDarken={darken}>
          <Image
            src={"images/carbon-lottie.png"}
            style={{
            height: '85vh'
          }}/>
        </Slide>
        <Slide bgImage={"images/bg-4.jpg"} bgDarken={darken}>
          <Heading
            style={{
            letterSpacing: 1,
            textShadow: "0px 0px 3px #000000",
            fontSize: "8em",
            textAlign: "center"
          }}
            textColor="primary">
            {"Conclusions"}
          </Heading>
        </Slide>
        <Slide bgImage={"images/bg-4.jpg"} bgDarken={darken}>
          <Heading
            style={{
            letterSpacing: 1,
            textShadow: "0px 0px 3px #000000",
            fontSize: "8em",
            textAlign: "center"
          }}
            textColor="primary">
            {"Thank You!"}
          </Heading>
          <Text
            margin={"20px auto"}
            style={{
            lineHeight: "1.25em",
            width: "50vw",
            textShadow: "0px 0px 3px #000000"
          }}
            textSize={60}
            textColor="primary"
            textFont={"Noto Sans"}>
            {"@zvona"}
          </Text>
          <Text
            margin={"20px auto"}
            style={{
            lineHeight: "1.25em",
            width: "50vw",
            textShadow: "0px 0px 3px #000000"
          }}
            textSize={60}
            textColor="primary"
            textFont={"Noto Sans"}>
            {"Illustration by @lyagva (Fiverr)"}
          </Text>
        </Slide>
        <Slide bgImage={"images/bg-0.jpg"} bgDarken={darken}>
          <Heading
            style={{
            letterSpacing: 1,
            textShadow: "0px 0px 3px #000000",
            width: "50vw",
            margin: "0px auto",
            fontSize: "8em",
            textAlign: "center"
          }}
            textColor="primary">
            {"Reasons to Visit in Finland"}
          </Heading>
          <Text
            margin={"20px auto"}
            style={{
            lineHeight: "1.25em",
            textShadow: "0px 0px 3px #000000"
          }}
            textSize={60}
            textColor="primary"
            textFont={"Noto Sans"}>
            {"GraphQL Finland: 18. - 19.10.2018"}
          </Text>
          <Text
            margin={"20px auto"}
            style={{
            lineHeight: "1.25em",
            textShadow: "0px 0px 3px #000000"
          }}
            textSize={60}
            textColor="primary"
            textFont={"Noto Sans"}>
            {"React Finland: Late May 2019"}
          </Text>
        </Slide>
      </Deck>
    );
  }
}



// WEBPACK FOOTER //
// ./src/presentation.js